<ng-container
    *im2mLet="{
        deviceList: deviceList$ | async,
        hasErrors: hasErrors$ | async,
        errors: errors$ | async,
        headerWarning: headerWarning$ | async,
        processing: processing$ | async,
        routerTypes: routerTypes$ | async,
        routerTypeOptions: routerTypeOptions$ | async
    } as tempData"
>
    <h3 mat-dialog-title>
        {{ (tempData?.deviceList.length > 0 ? 'DEVICES.IMPORT.PREVIEW' : 'DEVICES.IMPORT.TITLE') | transloco }}
    </h3>
    <mat-dialog-content class="content">
        <div class="processing" *ngIf="tempData?.processing">
            <mat-spinner></mat-spinner>
        </div>

        <div class="import-wrapper" [class.hidden]="tempData?.deviceList.length > 0 || tempData?.headerWarning?.length > 0">
            <div class="left">
                <span class="label">{{ 'DEVICES.IMPORT.SINGLE_IMPORT' | transloco }}</span>
                <form [formGroup]="singleForm" autocomplete="off">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'DEVICES.IMPORT.ROUTER_TYPE' | transloco }}</mat-label>
                        <mat-select formControlName="routerType">
                            <mat-select-trigger>
                                {{
                                    singleForm?.get('routerType')?.value
                                        ? singleForm?.get('routerType')?.value?.name +
                                          '
                                (' +
                                          (singleForm?.get('routerType')?.value?.vendor | uppercase) +
                                          ')'
                                        : undefined
                                }}
                            </mat-select-trigger>
                            <div class="vendor-options" *ngFor="let vendor of tempData?.routerTypeOptions">
                                <div class="label">
                                    {{ vendor.vendor | uppercase }}
                                </div>
                                <mat-option *ngFor="let type of vendor?.routerTypes" [value]="type">
                                    {{ type.name }}
                                </mat-option>
                            </div>
                            <mat-option *ngIf="(tempData?.routerTypeOptions || []).length === 0">
                                {{ 'NO_DATA' | transloco }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="singleForm.get('routerType')?.hasError('required')">
                            <span class="error-hint">{{ 'DEVICES.IMPORT.ROUTER_TYPE_HINT' | transloco }}</span>
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'DEVICES.IMPORT.SERIAL_NUMBER' | transloco }}</mat-label>
                        <input matInput formControlName="serialNumber" />
                        <mat-error *ngIf="singleForm.get('serialNumber')?.hasError(ERROR_KEYS.serialNumber)">
                            <span class="error-hint">{{ 'DEVICES.IMPORT.SERIAL_NUMBER_HINT' | transloco }}</span>
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'DEVICES.IMPORT.IMEI' | transloco }}</mat-label>
                        <input matInput formControlName="id" />
                        <mat-error *ngIf="singleForm.get('id')?.hasError(ERROR_KEYS.imei)">
                            <span class="error-hint">{{ 'DEVICES.IMPORT.IMEI_HINT' | transloco }}</span>
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'DEVICES.IMPORT.ICCID' | transloco }}</mat-label>
                        <input matInput formControlName="iccid" />
                        <mat-error *ngIf="singleForm.get('iccid')?.hasError(ERROR_KEYS.iccid)">
                            <span class="error-hint">{{ 'DEVICES.IMPORT.ICCID_HINT' | transloco }}</span>
                        </mat-error>
                    </mat-form-field>
                </form>
            </div>
            <div class="right">
                <span class="label">{{ 'DEVICES.IMPORT.MULTI_IMPORT' | transloco }}</span>
                <div class="upload-area" liebherrDropFile (filesChanged)="onFilesChanged($event, tempData?.routerTypes)">
                    <span class="upload-hint">{{ 'DEVICES.IMPORT.DROP_FILE' | transloco }}</span>
                    <span class="browse-hint">{{ 'DEVICES.IMPORT.OR_BROWSE' | transloco }}</span>
                    <input type="file" #uploader accept="text/csv" (change)="onFilesChanged($any($event?.target)?.files, tempData?.routerTypes)" />
                </div>
            </div>
        </div>
        <ng-container *im2mLet="displayedColumns$ | async as displayedColumns">
            <div class="preview-wrapper" *ngIf="tempData?.deviceList.length > 0 || tempData?.headerWarning?.length > 0">
                <span *ngIf="missingOptionalHeaders$ | async as missingOptionalHeaders" class="missing-header-hint">{{
                    'DEVICES.IMPORT.MISSING_OPTINAL_HEADER_HINT' | transloco : { headers: missingOptionalHeaders }
                }}</span>

                <div class="topline">
                    <span *ngIf="tempData?.deviceList.length > 0">
                        {{ tempData?.deviceList.length + ' ' + ('DEVICES.IMPORT.NEW_DEVICES' | transloco) }}
                    </span>
                    <button mat-icon-button color="primary" [matTooltip]="'DEVICES.IMPORT.REIMPORT' | transloco" [matTooltipPosition]="'right'" (click)="onReupload()">
                        <mat-icon>publish</mat-icon>
                    </button>
                </div>
                <span *ngIf="tempData?.headerWarning?.length > 0" class="header-warning">
                    <span class="hint">{{ 'DEVICES.IMPORT.HEADER_WARNING' | transloco }}</span>
                    <ul>
                        <li *ngFor="let headerKey of tempData?.headerWarning">
                            {{ headerKey }}
                        </li>
                    </ul>
                </span>

                <table *ngIf="!tempData?.headerWarning || tempData?.headerWarning?.length === 0" mat-table [dataSource]="tempData?.deviceList">
                    <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'DEVICES.IMPORT.' + column | transloco }}
                        </th>
                        <td mat-cell *matCellDef="let element" [ngSwitch]="column" [class.error]="column | liebherrHasError : element.errors">
                            <ng-container *ngSwitchCase="IMPORT_COLUMNS.ROUTER_TYPE">
                                {{ element.device.routerType || '-' }}
                            </ng-container>
                            <ng-container *ngSwitchCase="IMPORT_COLUMNS.SERIAL_NUMBER">
                                {{ element.device.serialNumber || '-' }}
                            </ng-container>
                            <ng-container *ngSwitchCase="IMPORT_COLUMNS.IMEI">
                                {{ element.device.id || '-' }}
                            </ng-container>
                            <ng-container *ngSwitchCase="IMPORT_COLUMNS.ICCID">
                                {{ element.device.iccid || '-' }}
                            </ng-container>
                            <ng-container *ngSwitchCase="IMPORT_COLUMNS.SIM_EXPIRATION_DATE">
                                {{ element.device.simExpirationDate || '-' }}
                            </ng-container>
                            <ng-container *ngSwitchCase="IMPORT_COLUMNS.FW_VERSION">
                                {{ element.device.firmwareVersion || '-' }}
                            </ng-container>
                            <ng-container *ngSwitchCase="IMPORT_COLUMNS.VENDOR">
                                {{ element.device.routerVendor || '-' }}
                            </ng-container>
                        </td>
                        <td mat-footer-cell *matFooterCellDef>
                            <ng-container [ngSwitch]="column">
                                <ng-container *ngSwitchCase="IMPORT_COLUMNS.ROUTER_TYPE">
                                    <ng-container
                                        *ngFor="
                                            let message of [ERROR_KEYS.routerTypeRequired, ERROR_KEYS.routerTypeInvalid, ERROR_KEYS.routerTypeVendorMatch] | liebherrErrorMessages : tempData?.errors
                                        "
                                    >
                                        <span class="error-message"> {{ message.translation | transloco : message.data }}</span>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngSwitchCase="IMPORT_COLUMNS.SERIAL_NUMBER">
                                    <ng-container *ngFor="let message of [ERROR_KEYS.serialNumber, ERROR_KEYS.serialNumberDuplicate] | liebherrErrorMessages : tempData?.errors">
                                        <span class="error-message"> {{ message.translation | transloco : message.data }}</span>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngSwitchCase="IMPORT_COLUMNS.IMEI">
                                    <ng-container *ngFor="let message of [ERROR_KEYS.imei, ERROR_KEYS.imeiDuplicate] | liebherrErrorMessages : tempData?.errors">
                                        <span class="error-message"> {{ message.translation | transloco : message.data }}</span>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngSwitchCase="IMPORT_COLUMNS.ICCID">
                                    <ng-container *ngFor="let message of [ERROR_KEYS.iccid, ERROR_KEYS.iccidDuplicate] | liebherrErrorMessages : tempData?.errors">
                                        <span class="error-message"> {{ message.translation | transloco : message.data }}</span>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngSwitchCase="IMPORT_COLUMNS.SIM_EXPIRATION_DATE">
                                    <ng-container *ngFor="let message of [ERROR_KEYS.date] | liebherrErrorMessages : tempData?.errors">
                                        <span class="error-message"> {{ message.translation | transloco : message.data }}</span>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngSwitchCase="IMPORT_COLUMNS.VENDOR">
                                    <ng-container *ngFor="let message of [ERROR_KEYS.vendor, ERROR_KEYS.vendorRouterTypeMatch] | liebherrErrorMessages : tempData?.errors">
                                        <span class="error-message"> {{ message.translation | transloco : message.data }}</span>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    <ng-container *ngIf="tempData?.hasErrors">
                        <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
                    </ng-container>
                </table>
            </div>
        </ng-container>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close (click)="onCancel()">
            {{ 'CLOSE' | transloco }}
        </button>
        <button
            mat-flat-button
            color="primary"
            [disabled]="tempData?.deviceList.length > 0 ? tempData?.hasErrors : singleForm.invalid || singleForm.pristine"
            (click)="onSubmit(tempData?.deviceList, tempData?.hasErrors)"
        >
            {{ 'SUBMIT' | transloco }}
        </button>
    </mat-dialog-actions>
</ng-container>
